import { render, staticRenderFns } from "./CommonParam.vue?vue&type=template&id=14a94d3c&scoped=true&"
import script from "./CommonParam.vue?vue&type=script&lang=js&"
export * from "./CommonParam.vue?vue&type=script&lang=js&"
import style0 from "./CommonParam.vue?vue&type=style&index=0&id=14a94d3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a94d3c",
  null
  
)

export default component.exports